import React from 'react';
import { Controls, InfoGroup, Wrapper } from './card-short-short-approval-manager-request.styles';
import { CardShortApprovalManagerRequestProps } from './types';
import { Typography } from '@shared/ui/typography/typography';
import { userName } from '@shared/lib/utils/user-name/user-name';
import dayjs from 'dayjs';
import { UserProfile } from '@shared/ui/user-profile/user-profile';

export const CardShortApprovalManagerRequest: React.FC<CardShortApprovalManagerRequestProps> = ({
    request,
    children,
    onClick,
}) => {
    const initiator = request?.user;

    const initiatorName = userName({
        firstName: initiator?.firstName || '',
        lastName: initiator?.lastName || '',
        middleName: initiator?.middleName || '',
    });

    return (
        <Wrapper onClick={onClick}>
            <InfoGroup $maxWidth={55}>
                <Typography size='body2_long' color='neutral_50'>
                    Дата
                </Typography>
                <Typography size='body2_long'>{dayjs(request.createdAt).format('DD.MM.YY')}</Typography>
            </InfoGroup>
            <InfoGroup $maxWidth={465}>
                <Typography size='body2_long' color='neutral_50'>
                    Название продукта
                </Typography>
                <Typography size='body2_long' color='neutral_90'>
                    {request.product?.name}
                </Typography>
            </InfoGroup>
            <InfoGroup $maxWidth={220}>
                <Typography size='body2_long' color='neutral_50'>
                    Инициатор
                </Typography>

                <UserProfile
                    text={initiatorName.short}
                    avatarUrl={initiator?.photoUrl}
                    size='s'
                    tooltipData={{
                        avatarUrl: initiator?.photoUrl,
                        name: initiatorName.full,
                        department: initiator?.department?.name || '-',
                        jobPost: initiator?.jobTitle,
                        email: initiator?.email,
                    }}
                />
            </InfoGroup>

            <Controls>{children}</Controls>
        </Wrapper>
    );
};
